module.exports = __webpack_public_path__ + "static/media/hero_banner.f2ef3020.jpg";